<template></template>
<script>
    import moment from 'moment'
    export default {
        methods: {
            formConvert(data) {
                this.form = data;
                this.form.img_in_content = Boolean(this.form.img_in_content)

                this.extraContent = this.form.content;

                //是否有原文链接
                this.has_source_url = !!data.source_url

                //是否有多媒体
                this.has_media = !!data.media_type

                //是否允许环视发布
                this.change_publish = !!(data.publish_begin || data.publish_end)

                //publish_at时间转换
                this.form.publish_at = moment.unix(data.publish_at).format('YYYY-MM-DD HH:mm')

                //publish_begin publish_end 转换
                if (data.publish_begin || data.publish_end) {
                    this.publish_between = [moment.unix(data.publish_begin).format('YYYY-MM-DD HH:mm'), moment.unix(
                        data.publish_end).format('YYYY-MM-DD HH:mm')]
                }

                //封面图片
                this.form.artwork = [];
                this.artworkList = [];
                this.artwork = data.attachment.map(v => {
                    this.form.artwork.push(v.url)
                    this.artworkList.push({
                        response: {
                            data: {
                                name: '附件图片',
                                url: v.url
                            }
                        },
                        url: v.url
                    })
                })

                //微博直发转发
                this.type = data.url ? 'two' : 'one'

                //推广地区
                this.promotion_area = !this.form.promotion_area

                //百度云，链接地址
                this.has_video_url = !!this.form.url

                //资质证明
                if (data.certificate_id) {
                    this.certFileList = [{
                        'name': '资质证明',
                        'url': document.URL
                    }]
                }
            },
            load() {
                this.loading = true;
                this.$http.get(`manuscripts/${this.$route.params.id}`).then(res => {
                    if (res.success) {
                        this.formConvert(res.data);
                    }
                }).catch().then(() => {
                    this.loading = false
                })
            },
            onSubmit() {
                this.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        this.submitting = true;
                        if (this.$route.meta._meta === "edit") {
                            return this.onUpdate();
                        } else {
                            return this.onStore();
                        }
                    } else {
                        return false;
                    }
                });
            },
            handleManChange(item) {
                this.formConvert(item)
                this.extraContent = item.content
            },

            loadIndustry(taxonomy) {
                this.$http
                    .get(`/basic_data/industry?fetch_all=1&taxonomy=${taxonomy}`)
                    .then(response => {
                        if (response.success) {
                            this.industry = response.data
                        }
                    })
            },
            loadOrder() {
                if (this.order_id) {
                    this.orderLoading = true
                    this.$http.get("order_resource/" + this.order_id).then(response => {
                        if (response.success) {
                            this.order = response.data;
                        }
                    }).catch().then(() => {
                        this.orderLoading = false
                    })
                }
            },
            onStore() {

                if (this.order.order_id) {
                    this.form["order_id"] = this.order.order_id;
                }


                this.$http
                    .post("/manuscripts", this.form)
                    .then(response => {
                        if (response.success) {
                            if (response.data.order_id) {
                                //有稿件的，询问是否直接支付
                                return this.onPay(response.data.order_id);
                            } else {
                                return this.$router.push("/own/manuscripts");
                            }
                        } else {
                            this.$alert(response.message, "失败", {
                                type: "error"
                            });
                        }
                    })
                    .catch()
                    .then(() => (this.submitting = false));
            },
            onPay(order_id) {

                this.$alert('稿件创建成功，是否立即支付?（订单支付后，稿件将不能修改）', "创建成功", {
                    confirmButtonText: "支付",
                    cancelButtonText: '取消',
                    showCancelButton: true,
                    type: "success",
                    beforeClose: (action, instance, done) => {
                        if (action === "confirm") {
                            instance.confirmButtonLoading = true;
                            instance.confirmButtonText = "处理中...";

                            this.$http
                                .post("payment/request", {
                                    order_id: order_id
                                })
                                .then(res => {
                                    if (res.success) {
                                        instance.callback = () => {
                                            this.$router.push("/own/order/" + order_id);
                                        };
                                    } else {
                                        instance.callback = () => {
                                            this.$alert(res.message, "失败", {
                                                type: "error",
                                                callback: () => {
                                                    this.$router.push("/own/order/" +
                                                        order_id);
                                                }
                                            })
                                        };
                                    }
                                })
                                .catch()
                                .then(() => {
                                    this.loading = false;
                                    instance.confirmButtonLoading = false;
                                    done();
                                });
                        } else {
                            //直接跳转
                            this.$router.push("/own/order/" + order_id);
                            done();
                        }
                    }
                });
            },
            onUpdate() {
                this.$http
                    .put("/manuscripts/" + this.$route.params.id, this.form)
                    .then(response => {
                        if (response.success) {
                            this.$alert(response.message+'<a class="link active" href="/manuscripts/'+this.$route.params.id+'" target="_blank">点击预览稿件</a>', "成功", {
                                confirmButtonText: "好的",
                                dangerouslyUseHTMLString:true,
                                type: "success",
                                callback: action => {
                                    this.$router.push("/own/manuscripts");
                                }
                            });
                        } else {
                            this.$alert(response.message, "失败", {
                                type: "error"
                            });
                        }
                    })
                    .catch()
                    .then(() => (this.submitting = false));
            },
            handleArtworkChange(file, fileList) {
                this.form.artwork = [];
                fileList.map(v => {
                    if (v.response) {
                        this.form.artwork.push(v.response.data.url)
                    }
                })
            },
            handleCertSuccess(file) {
                if (file.success) {
                    this.form.certificate_id = file.data.object_id;
                    this.certFileList = [{
                        name: '资质证明',
                        url: file.data.url
                    }]
                }
            },
            handleCertSelected(obj) {
                this.form.certificate_id = obj.id;
                this.certFileList = [{
                    name: '资质证明',
                    url: obj.url
                }]
            },
        }
    };

</script>



// WEBPACK FOOTER //
// src/mixins/ManuscriptSubmit.vue